import React, { useState, useEffect } from "react";
import LoanDataService from "../services/LoanService";

const Loan = props => {
  const initialLoanState = {
    amount: "",
    previousBalance: "",
    newBalance: ""
  };
  const [currentLoan, setCurrentLoan] = useState(initialLoanState);
  const [message, setMessage] = useState("");

  const getLoan = id => {
    // service will try /doc/:id then fallback owner/:id
    LoanDataService.get(id)
      .then(response => {
        setCurrentLoan(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getLoan(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentLoan({ ...currentLoan, [name]: value });
  };

  const updateLoan = () => {
    // extract owner id if owner is populated as object
    const ownerArg = currentLoan?.owner && typeof currentLoan.owner === "object"
      ? (currentLoan.owner._id || currentLoan.owner.id || currentLoan.owner)
      : currentLoan?.owner;

    LoanDataService.update(currentLoan.id, currentLoan, ownerArg)
      .then(response => {
        console.log(response.data);
        setMessage("Loan transactions was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });
  };

  const deleteLoan = () => {
    const ownerArg = currentLoan?.owner && typeof currentLoan.owner === "object"
      ? (currentLoan.owner._id || currentLoan.owner.id || currentLoan.owner)
      : currentLoan?.owner;

    LoanDataService.remove(currentLoan.id, ownerArg)
      .then(response => {
        console.log(response.data);
        props.history.push("/loan");
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentLoan ? (
        <div className="edit-form">
          <h4>Loan Transactions</h4>
          <form>
            <div className="form-group">
              <label htmlFor="amount">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                name="amount"
                value={currentLoan.amount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="previousBalance">Previous Balance</label>
              <input
                type="text"
                className="form-control"
                id="previousBalance"
                name="previousBalance"
                value={currentLoan.previousBalance}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newBalance">New Balance</label>
              <input
                type="text"
                className="form-control"
                id="newBalance"
                name="newBalance"
                value={currentLoan.newBalance}
                onChange={handleInputChange}
              />
            </div>
          </form>      

          <button className="badge badge-danger mr-2" onClick={deleteLoan}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateLoan}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on a Loan Transaction...</p>
        </div>
      )}
    </div>
  );
};

export default Loan;
